<script lang="ts">
  import ActionButton from '~/components/ActionButton.svelte';
  import { getCustomerPortal, getSubscriptionQuery } from './mutations.svelte';
  import Spinner from '~/components/Spinner.svelte';
  import SubscribeCard from './SubscribeCard.svelte';

  const portal = getCustomerPortal();
  const subscription = getSubscriptionQuery();

  const handleClickPortal = async () => {
    const res = await portal.mutateAsync();
    window.location.replace(res.url);
  };
</script>

<div class="manage-subscription">
  {#if subscription.data}
    <ActionButton
      class="primary"
      onClick={handleClickPortal}
      disabled={portal.isPending}
    >
      {#if portal.isPending || portal.isSuccess}
        <Spinner />
      {:else}
        Manage Subscription
      {/if}
    </ActionButton>
  {:else}
    <SubscribeCard />
  {/if}
</div>

<style lang="scss">
  @use '~/theme/theme';
  @use 'sass:color';

  .manage-subscription {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 1em;
    :global(.action) {
      height: 48px;
      width: 80%;
      justify-content: center;
    }
  }
</style>
